import brandLogo from "@/assets/brand-logo.webp";

export const BrandLogo = ({ className = "" }: { className?: string }) => {
  return (
    <span className={`inline-flex items-center gap-2 ${className}`}>
      <img
        src={brandLogo}
        alt="Conceptions.ma logo"
        className="size-10 object-contain drop-shadow-sm"
        loading="eager"
        decoding="async"
      />
      <span className="flex flex-col leading-none">
        <span className="font-extrabold tracking-tight text-foreground text-lg">
          Conceptions<span style={{ color: "#9E7C1F" }}>.ma</span>
        </span>
        <span className="text-[10px] font-medium uppercase tracking-wider text-muted-foreground">
          powered by Adhorizon
        </span>
      </span>
    </span>
  );
};
